const GRID_BOX = {image:"",title:"",type:"",link:""};

const EACH_SECTION = [
        GRID_BOX,
        GRID_BOX,
        GRID_BOX
    ];

const TAB_SECTION = {
    section_heading : "",
    section_row : EACH_SECTION
}

const INITIAL_KNOWLEDGE_CENTER_POPUP = {
    bucket:{
        cleartrail: {
            disable: "no",
            data : [
                // {
                //     tabtitle : "Sessions",
                //     requestdemoname: "",
                //     disable: "",
                //     inner_data : [
                //         TAB_SECTION
                //     ]
                // },
                {
                    tabtitle : "About",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/Corporate-Profile.jpg",title:"About ClearTrail Technologies",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/Corporate-Profile.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/CT-Product-Booklet.jpg",title:"Product Booklet",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/CT-Product-Booklet_web.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/ClearTrail-Technologies-Introduction-1.jpg",title:"ClearTrail Technologies Introduction",type:"Video",link:"https://player.vimeo.com/video/551867775"}
                            ]
                        }
                    ]
                },  
                {
                    tabtitle : "CARBN.AI",
                    requestdemoname: "Trial",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/CARBN.jpg",title:"Experience the Future of IP Data Analytics",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/CARBN.AI-IPDR-Brochure-web.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/carbn-demo.jpg",title:"Video",type:"Video",link:"https://player.vimeo.com/video/953097860"}
                            ]
                        }
                    ]
                }, 
                  {
                    tabtitle : "SnapShot K.1",
                    requestdemoname: "Trial ",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/SnapShot-K.jpg",title:"Non-Intrusive Pentest",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/SnapShot-K.1-Brochure_web.pdf"},
                                
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/SnapShot-K-demo.jpg",title:"Video",type:"Video",link:"https://player.vimeo.com/video/877777988"}
                            ]
                        }
                    ]
                }, 
                {
                    tabtitle : "Infinium",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/Infinium.jpg",title:"AI-Powered Decision Operating System",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/Infinium-Brochure_web.pdf"}
                            ]
                        }
                    ]
                }, 
                {
                    tabtitle : "ComTrail",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/ComTrail.jpg",title:"Next-Gen Lawful Interception Platform",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/ComTrail-Brochure-web.pdf"},

                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/ComTrail-demo.jpg",title:"Video",type:"Video",link:"https://player.vimeo.com/video/720569266"}
                            ]
                        }
                    ]
                }, 
                {
                    tabtitle : "MetaTrail",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/MetaTrail-Cyber-scaled.jpg",title:"MetaTrail ",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/MetaTrail-Cyber-_Brochure-2025_web.pdf"}
                            ]
                        }
                    ]
                }, 
                {
                    tabtitle : "Orion",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/ORION.jpg",title:"Secure • Scalable • Sovereign Cloud",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/ClearTrail-ORION.pdf"}
                            ]
                        }
                    ]
                }, 
                {
                    tabtitle : "Data Centre Solutions",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2025/08/Data-Centre-Solutions.jpg",title:"Building the Future of Secure Government Infrastructure",type:"brochure",link:"https://community-wp.ciisummit.com/private/thumbs/ClearTrail-Data-Centre-Solutions.pdf"}
                            ]
                        }
                    ]
                }  
                // {
                //     tabtitle : "Statgrid",
                //     requestdemoname: "",
                //     disable: "",
                //     inner_data : [
                //         {
                //             section_heading : "",
                //             section_row : [
                //                 {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/Statgrid-brochuer.jpg",title:"Statgrid: Concept note",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_Concept_Note_Statgrid.pdf"}
                //             ]
                //         }
                //     ]
                // },  
            ]   
        },
        mppolice: {
            
        }
    },
    datatrack: 0
}

const KnowledgeCenterBucket = (state = INITIAL_KNOWLEDGE_CENTER_POPUP, action) => {
    switch(action.type){
        case "SET_KNOWLEDGE_DATA":
            return {
                ...state,
                bucket: action.payload,
                datatrack: 0
            }
        case "SET_KNOWLEDGE_DATATRACK":
            return INITIAL_KNOWLEDGE_CENTER_POPUP
        default:
            return state
    }
}

export default KnowledgeCenterBucket;